// import request from "@/utils/request";
import request, { uploadFile } from '@/utils/request'
/* 用户注册 */
export function registerApi (params) {
  return request({
    url: '/app-api/business/auth/register',
    method: 'post',
    data: params
  })
}
/* 登录 */
export function loginApi (params) {
  return request({
    url: '/app-api/business/auth/login',
    method: 'post',
    data: params
  })
}
/* 获取用户信息 */
export function getUserInfo (params) {
  return request({
    url: '/app-api/business/user/get',
    method: 'GET',
    params

  })
}
/* 获取消息通知 */
export function getMessageList (params) {
  return request({
    url: '/app-api/business/message/page',
    method: 'GET',
    params
  })
}
/* 获取消息通知 */
export function getMessage (params) {
  return request({
    url: '/app-api/business/message/get',
    method: 'GET',
    params
  })
}
/* 获取热门培训 */
export function getCourseHome (params) {
  return request({
    url: '/app-api/business/course/home',
    method: 'GET',
    params
  })
}
/* 获取培训列表 */
export function getCourseList (params) {
  return request({
    url: '/app-api/business/course/page',
    method: 'GET',
    params
  })
}
/* 获取课程分类 */
export function getCourseClass (params) {
  return request({
    url: '/app-api/business/course/class',
    method: 'GET',
    params
  })
}
/* 获取课程详情 */
export function getCourseGet (params) {
  return request({
    url: '/app-api/business/course/get',
    method: 'GET',
    params
  })
}
/* 创建订单 */
export function orderCreate (params) {
  return request({
    url: '/app-api/business/order/create',
    method: 'post',
    data: params
  })
}
/* 拉起微信支付 */
export function orderSubmit (params) {
  return request({
    url: '/app-api/business/pay/order/submit',
    method: 'post',
    data: params
  })
}
/* 支付成功 */
export function orderSuccess (params) {
  return request({
    url: '/app-api/business/order/success',
    method: 'post',
    data: params
  })
}

/* 刷新token */
export function refreshTokenApi (params) {
  return request({
    url: '/app-api/business/auth/refresh-token',
    method: 'post',
    data: params
  })
}
/* 我的培训 */
export function courseMyApi (params) {
  return request({
    url: '/app-api/business/course/web/my',
    method: 'get',
    params
  })
}
/* 课程详情 */
export function courseDetailsApi (params) {
  return request({
    url: '/app-api/business/course/get',
    method: 'get',
    params
  })
}

/* 课程详情 新 */
export function courseDetailsUnitApi (params) {
  return request({
    url: '/app-api/business/course/getUnit',
    method: 'get',
    params
  })
}

/* 更新观看进度 */
export function speedProgressApi (params) {
  return request({
    url: '/app-api/business/speed-progress/update',
    method: 'post',
    data: params
  })
}
/* 获得试卷信息 */
export function examGetApi (params) {
  return request({
    url: '/app-api/business/exam/get',
    method: 'get',
    params
  })
}
/* 提交试卷 */
export function examSubmitApi (params) {
  return request({
    url: '/app-api/business/exam/submit',
    method: 'post',
    data: params
  })
}
/* 培训进度 */
export function certificateSuccessApi (params) {
  return request({
    url: '/app-api/business/certificate/success',
    method: 'get',
    params
  })
}
/* 消息通知分页 */
export function messagePageApi (params) {
  return request({
    url: '/app-api/business/message/page',
    method: 'get',
    params
  })
}
/* 获得订单分页 */
export function orderPageApi (params) {
  return request({
    url: '/app-api/business/order/page',
    method: 'get',
    params
  })
}
/* 获得公司信息 */
export function companyInfoGet (params) {
  return request({
    url: '/app-api/business/company-info/get',
    method: 'get',
    params
  })
}
/* 获得承诺书 */
export function clauseGet (params) {
  return request({
    url: '/app-api/business/clause/get',
    method: 'get',
    params
  })
}

/* 提交同意承诺书 */
export function userAgree (params) {
  return request({
    url: '/app-api/business/clause/userAgree',
    method: 'get',
    params
  })
}

/* 文件上传 */
export function uploadFileApi (formData) {
  return uploadFile('/app-api/business/file/upload', formData)
}

/* 学员导入 */
export function exportReadApi (formData) {
  return uploadFile('/app-api/business/lbyUserStudent/export-read', formData)
}

/* 实名认证 */
export function userCardAuthentication (formData) {
  return uploadFile('/app-api/business/userInfoCard/userCardAuthentication', formData)
}

/* 人脸识别 */
export function userImgAuthentication (formData) {
  return uploadFile('/app-api/business/userInfoCard/userImgAuthentication', formData)
}

/* 学习过程人脸比对 */
export function faceCompareApi (formData) {
  return uploadFile('/app-api/business/user/face-compare', formData)
}

/* 管理发票信息 */
export function ticketPage (params) {
  return request({
    url: '/app-api/business/ticket/page',
    method: 'get',
    params
  })
}

/* 添加公司票头信息 */
export function addUserTicketUp (params) {
  return request({
    url: '/app-api/business/ticket/addUserTicketUp',
    method: 'post',
    data: params
  })
}

/* 查询发票类型 */
export function selectDataByTicket (params) {
  return request({
    url: '/app-api/business/ticket/selectDataByTicket',
    method: 'get',
    params
  })
}

/* 修改公司票头信息 */
export function updateUserTicketUp (params) {
  return request({
    url: '/app-api/business/ticket/updateUserTicketUp',
    method: 'post',
    data: params
  })
}

/* 查询已申请发票信息(分页) */
export function ticketOrderPage (params) {
  return request({
    url: '/app-api/business/ticket/ticketOrderPage',
    method: 'get',
    params
  })
}

/* 查询开票得订单(分页) */
export function selectOrderPage (params) {
  return request({
    url: '/app-api/business/ticket/selectOrderPage',
    method: 'get',
    params
  })
}
/* 我的考试(分页) */
export function selectExam (params) {
  return request({
    url: '/app-api/business/exam/my',
    method: 'get',
    params
  })
}

/* 申请发票提交接口 */
export function lbyUserTicketOrderUp (params) {
  return request({
    url: '/app-api/business/ticket/lbyUserTicketOrderUp',
    method: 'post',
    data: params
  })
}

/* 查询发票信息和可开金额得信息 */
export function getTicketAndMoneyInfo (params) {
  return request({
    url: '/app-api/business/ticket/getTicketAndMoneyInfo',
    method: 'get',
    params
  })
}

/* 查看发票详情 */
export function getDataByTicketInfo (params) {
  return request({
    url: '/app-api/business/ticket/getDataByTicketInfo',
    method: 'get',
    params
  })
}

/* 意见反馈 */
export function userFeedBackUp (params) {
  return request({
    url: '/app-api/business/feedback/userFeedBackUp',
    method: 'post',
    data: params
  })
}

/* 查询问题类型（字典数据） */
export function selectFeedBackType (params) {
  return request({
    url: '/app-api/business/feedback/selectFeedBackType',
    method: 'get',
    params
  })
}

/* 查询问题类型（字典数据） */
export function selectFeedbackDataByTicket (params) {
  return request({
    url: '/app-api/business/feedback/selectDataByTicket',
    method: 'get',
    params
  })
}

/* 获得试卷考试记录分页 */
export function examRecordPageApi (params) {
  return request({
    url: '/app-api/business/exam-record/page',
    method: 'get',
    params
  })
}

/* 获得试卷考试记录详情 */
export function examRecordDetailApi (params) {
  return request({
    url: '/app-api/business/exam-record/detail',
    method: 'get',
    params
  })
}

/* 修改基本信息 */
export function userUpdateApi (params) {
  return request({
    url: '/app-api/business/user/update',
    method: 'post',
    data: params
  })
}

/* 课程培训进度详细 */
export function learnProgressApi (params) {
  return request({
    url: '/app-api/business/course/learn-progress',
    method: 'get',
    params
  })
}

/* 获得课程学习进度 */
export function learningProgressApi (params) {
  return request({
    url: '/app-api/business/course/learning-progress',
    method: 'get',
    params
  })
}

/* 企业获得课程学员档案 */
export function studentProfile (params) {
  return request({
    url: '/app-api/business/user/company',
    method: 'get',
    params
  })
}

/* 企业获得课程学员信息 */
export function studentUserInfo (params) {
  return request({
    url: '/app-api/business/user/info',
    method: 'get',
    params
  })
}

/* 企业获得课程学习日志 */
export function getLearningLogs (params) {
  return request({
    url: '/app-api/business/learning-diary/page',
    method: 'get',
    params
  })
}
/* 企业获得课程考试试卷 */
export function getExamuser (params) {
  return request({
    url: '/app-api/business/exam/user',
    method: 'get',
    params
  })
}

/* 获取订单详情 */
export function getOrderDetail (params) {
  return request({
    url: '/app-api/business/order/get',
    method: 'get',
    params
  })
}
// 查询订单支付状态
export function getOrderPayStatus (params) {
  return request({
    url: '/app-api/business/pay/order/get',
    method: 'get',
    params
  })
}
// 查询岗位范畴
export function selectWorkTypeList (params) {
  return request({
    url: '/app-api/business/course/selectWorkTypeList',
    method: 'get',
    params
  })
}

/* 查询学员 */
export function lbyUserStudentPage (params) {
  return request({
    url: '/app-api/business/lbyUserStudent/page',
    method: 'get',
    params
  })
}
// 创建学员
export function lbyUserStudentCreate (params) {
  return request({
    url: '/app-api/business/lbyUserStudent/create',
    method: 'post',
    data: params
  })
}
// 修改学员
export function lbyUserStudentUpdate (params) {
  return request({
    url: '/app-api/business/lbyUserStudent/update',
    method: 'post',
    data: params
  })
}

/* 删除学员 */
export function lbyUserStudentDelete (params) {
  return request({
    url: '/app-api/business/lbyUserStudent/delete',
    method: 'get',
    params
  })
}

/* 下载模板 */
export function selectDownload (params) {
  return request({
    url: '/app-api/business/lbyUserStudent/selectDownload',
    method: 'get',
    params
  })
}

/* 背题模式 根据章节Id获取 */
export function questionByChapter (params) {
  return request({
    url: '/app-api/business/question-bank/questionByChapter',
    method: 'get',
    params
  })
}
/* 模拟练习 根据章节Id获取 */
export function mockExam (params) {
  return request({
    url: '/app-api/business/question-bank/mockExam',
    method: 'get',
    params
  })
}
